import { OrderFormStepProps } from '../../enums/order-entry-props.enum';
import { PatientDto } from 'src/app/models';
import { OrderDto } from '../../models/order-dto';
import { OrderStepCode } from '../../enums/order-step-code.enum';
import { Test } from 'src/shared/models/test.model';
import { PatientModel } from 'src/app/pages/patients/models/patient.model';
import { OrderModel } from '../../models/order.model';
import { Diagnosis } from '../../models/diagnosis.model';
import { PatientSnapshotModel } from 'src/app/models/patient-snapshot.model';

export class SaveOrderAsDraft {
  public static readonly type = '[Order] Save order as draft';
}

export class SaveDraftOrder {
  public static readonly type = '[Order] Save draft order';
}

export class DraftOrderSaveStarted {
  public static readonly type = '[Order] Draft Order Save Started';
}

export class DraftOrderSaveEnded {
  public static readonly type = '[Order] Draft Order Save Ended';
}

export class StartFetchOrderPatient {
  public static readonly type = '[Order] Fetch Patient Start';

  constructor(public readonly patientId: number) {}
}
export class StartFetchOrderPatientSnapshot {
  public static readonly type = '[Order] Fetch Patient Snapshot Start';

  constructor(public readonly orderId: OrderDto['id']) {}
}

export class FetchOrderPatientSucceeded {
  public static readonly type = '[Order] Fetch Patient Success';

  constructor(public readonly payload: PatientDto) {}
}
export class FetchOrderPatientSnapshotSucceeded {
  public static readonly type = '[Order] Fetch Patient Snapshot Success';

  constructor(public readonly patientSnapshotModel: PatientSnapshotModel) {}
}

export class StartFetchOrder {
  public static readonly type = '[Order] Fetch Order Start';

  constructor(public readonly orderId: number) {}
}

export class FetchOrderSuccess {
  public static readonly type = '[Order] Fetch Order Success';

  constructor(public readonly order: OrderDto) {}
}

export class CreateNewOrder {
  public static readonly type = '[Order] Create New Order';

  constructor(public readonly payload: { patientId: PatientDto['id'] }) {}
}

export class DefaultOrderCreated {
  public static readonly type = '[Order] Default Order Created';

  constructor(public readonly order: OrderDto) {}
}

export class OrderCreatedSuccess {
  public static readonly type = '[Order] Order Created Success';

  constructor(public readonly orderModel: OrderModel) {}
}

export class OrderUpdatedSuccess {
  public static readonly type = '[Order] Order Updated Success';

  constructor(public readonly orderModel: OrderModel) {}
}

export class ChangeOrderCreateToOrderEdit {
  public static readonly type = '[Order] Navigate To Edit Order';

  constructor(public readonly id: number) {}
}

export class NavigateToOrderNextStep {
  public static readonly type = '[Order] Navigate To Next Step';
}

export class NavigateToOrderStep {
  public static readonly type = '[Order] Navigate To Step';

  constructor(public readonly stepName: OrderFormStepProps) {}
}

export class NavigateToOrderPreviousStep {
  public static readonly type = '[Order] Navigate To Previous Step';
}

export class SetCurrentOrderFormStep {
  public static readonly type = '[Order] Navigated To Step from browser';

  constructor(public readonly stepName: OrderFormStepProps) {}
}

export class PatientUpdatedSuccessfully {
  public static readonly type = '[Order] Patient Updated Successfully';

  constructor(public readonly patient: PatientModel) {}
}

export class UpdateCurrentStep {
  public static readonly type = '[Order] Update Current Step';

  constructor(public readonly step: OrderStepCode) {}
}

export class StartOrderSave {
  public static readonly type = '[Order] Start Order Save';
}

export class OrderSaveCompleted {
  public static readonly type = '[Order] Order Save Completed';
}

export class AddTests {
  public static readonly type = '[Order] Add Tests';

  constructor(public readonly payload: Test[]) {}
}

export class RemoveTests {
  public static readonly type = '[Order] Remove Tests';

  constructor(public readonly payload: Test[]) {}
}

export class RemoveTestById {
  public static readonly type = '[Order] Remove Test By Id';

  constructor(public readonly payload: Test['id']) {}
}

export class RemoveProfileExplosionTests {
  public static readonly type = '[Order] Remove Profile Explosion Tests';
}

export class LabUnavailableDetected {
  public static readonly type = '[Order] Lab Unavailable Detected';
}

export class ProceedNextStep {
  public static readonly type = '[Order] Proceed Next Step';
}

export class AddDiagnosis {
  public static readonly type = '[Order] Add Diagnosis';

  constructor(public readonly payload: Diagnosis | Diagnosis[]) {}
}

export class RemoveDiagnosis {
  public static readonly type = '[Order] Remove Diagnosis';

  constructor(public readonly payload: Diagnosis) {}
}

export class ClearDiagnosis {
  public static readonly type = '[Order] Clear Diagnosis';
}

export class ClearOrderDiagnoses {
  public static readonly type = '[Order] Clear Diagnoses for Bill Type';
}

export class RemoveDiagnosisById {
  public static readonly type = '[Order] Remove Diagnosis';

  constructor(public readonly id: Diagnosis['id']) {}
}

export class OrderFormValidationFailed {
  public static readonly type = '[Order] Order Form Validation Failed';
}

export class OrderFormDemographicsStepValidationFailed {
  public static readonly type = '[Order] Order Form Demographics Validation Failed';
}

export class OrderFormOrderInfoStepValidationFailed {
  public static readonly type = '[Order] Order Form Order Info Validation Failed';
}

export class OrderFormTestsStepValidationFailed {
  public static readonly type = '[Order] Order Form Tests Validation Failed';
}

export class OrderFormDiagnosisStepValidationFailed {
  public static readonly type = '[Order] Order Form Diagnosis Validation Failed';
}

export class OrderFormAdditionalInfoStepValidationFailed {
  public static readonly type = '[Order] Order Form Additional Info Validation Failed';
}
export class OrderPatientRequiredFieldsMissing {
  public static readonly type = '[Order] Order Patient Required Fields Missing';

  constructor(public readonly patientId: PatientDto['id']) {}
}

export class OrderPatientIdNotMatchedWithPatientId {
  public static readonly type = '[Order] Order Patient Id Not Matched With Patient Id';
}

export class ShowCollectionGuidancePDFModal {
  public static readonly type = '[Order] Show Collection Guidance PDF Modal';
}

export class ShowAbnModal {
  public static readonly type = '[Order] Show ABN Modal';

  constructor(public readonly diagnosisIds?: number[]) {}
}
